import { put, takeLatest, call } from "redux-saga/effects";
import {
    GET_P2A_RESPONSE_COUNTS_REQUESTED,
    GET_P2A_RESPONSE_COUNTS_SUCCESS,
    GET_P2A_RESPONSE_COUNTS_FAILED,
} from "../actions/ActionType";
import { API_ENDPOINT } from "../URLs/ApiEndpoints";
import { makeSecuredPostRequest } from "../../appApi/AppApi";
import { createActionOf } from "../actions/ActionCreator";

function* workerGetP2AResponseCounts(payLoad) {
  let response = {};
  try {    
    response = yield call(
      makeSecuredPostRequest,
      API_ENDPOINT.GET_P2A_RESPONSE_COUNTS, 
      payLoad.data
    );    
    yield put(createActionOf(GET_P2A_RESPONSE_COUNTS_SUCCESS, 1, response));
  } catch (error) {
    yield put(createActionOf(GET_P2A_RESPONSE_COUNTS_FAILED, 2, error));
  }
}

export const watchGetP2AResponseCounts = takeLatest(
  GET_P2A_RESPONSE_COUNTS_REQUESTED,
  workerGetP2AResponseCounts
);